import { render, staticRenderFns } from "./RiskCalculationWithTable.vue?vue&type=template&id=1fe1a2a1&scoped=true"
import script from "./RiskCalculationWithTable.vue?vue&type=script&lang=js"
export * from "./RiskCalculationWithTable.vue?vue&type=script&lang=js"
import style0 from "./RiskCalculationWithTable.vue?vue&type=style&index=0&id=1fe1a2a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe1a2a1",
  null
  
)

export default component.exports